class Header {

  static handleHeaderVisibility (scrollDirection) {
    let headers = document.querySelectorAll('#overflow-wrapper > header');

    if(headers.length) {
      for(let header of Array.from(headers)) {
        Header.updateOnScroll(header, scrollDirection)
      }
    }
  }

  static updateOnScroll (header, scrollDirection) {
    if(window.pageYOffset > header.offsetHeight) {
      if(scrollDirection === 'down') {
        header.classList.remove('fixed');

        // close menu if header fades out
        let menuentries = document.querySelectorAll('.main-navigation ul li.sub');

        if(menuentries.length) {
          for (let entry of Array.from(menuentries)) {
            entry.classList.remove('opened');
          }
        }
      } else {
        header.classList.add('fixed');
        header.classList.add('animate');
      }
    } else if(window.pageYOffset === 0) {
      if(!document.getElementById('menu-button').classList.contains('active')) {
        header.classList.remove('fixed');
        header.classList.remove('animate');
      }
    }
  }
}

export {
  Header
};